const s3BucketUrl = 'https://yns-com.s3.us-east-2.amazonaws.com/fonts/'
const fontUrl = (filename) => `${s3BucketUrl}${filename}`

export const archivo = {
  family: 'Archivo',
  fonts: [
    {
      src: fontUrl('Archivo-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Archivo-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('Archivo-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Archivo-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const poppins = {
  family: 'Poppins',
  fonts: [
    {
      src: fontUrl('Poppins-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Poppins-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('Poppins-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Poppins-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const dejaVuSans = {
  family: 'DejaVu Sans',
  fonts: [
    {
      src: fontUrl('DejaVuSans.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('DejaVuSans-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('DejaVuSans-Oblique.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('DejaVuSans-BoldOblique.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const openSans = {
  family: 'Open Sans',
  fonts: [
    {
      src: fontUrl('OpenSans-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('OpenSans-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('OpenSans-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('OpenSans-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const tinos = {
  family: 'Tinos',
  fonts: [
    {
      src: fontUrl('Tinos-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Tinos-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('Tinos-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Tinos-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const liberationSans = {
  family: 'Liberation Sans',
  fonts: [
    {
      src: fontUrl('LiberationSans-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('LiberationSans-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('LiberationSans-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('LiberationSans-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const caladea = {
  family: 'Caladea',
  fonts: [
    {
      src: fontUrl('Caladea-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Caladea-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('Caladea-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Caladea-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const carlito = {
  family: 'Carlito',
  fonts: [
    {
      src: fontUrl('Carlito-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Carlito-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('Carlito-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Carlito-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const gelasio = {
  family: 'Gelasio',
  fonts: [
    {
      src: fontUrl('Gelasio-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Gelasio-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Gelasio-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('Gelasio-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const ebGaramond = {
  family: 'EB Garamond',
  fonts: [
    {
      src: fontUrl('EBGaramond-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('EBGaramond-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('EBGaramond-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('EBGaramond-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const roboto = {
  family: 'Roboto',
  fonts: [
    {
      src: fontUrl('Roboto-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Roboto-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('Roboto-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Roboto-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
  ],
}

export const lora = {
  family: 'Lora',
  fonts: [
    {
      src: fontUrl('Lora-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Lora-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Lora-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('Lora-BoldItalic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('Lora-SemiBold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'semibold',
    },
  ],
}

export const inter = {
  family: 'Inter',
  fonts: [
    {
      src: fontUrl('Inter_18pt-Regular.ttf'),
      fontStyle: 'normal',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Inter_18pt-Italic.ttf'),
      fontStyle: 'italic',
      fontWeight: 'normal',
    },
    {
      src: fontUrl('Inter_18pt-Bold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'bold',
    },
    {
      src: fontUrl('Inter_18pt-SemiBold.ttf'),
      fontStyle: 'normal',
      fontWeight: 'semibold',
    },
  ],
}

const fonts = [
  archivo,
  poppins,
  roboto,
  lora,
  inter,
  liberationSans,
  caladea,
  ebGaramond,
  carlito,
  dejaVuSans,
  gelasio,
  tinos,
  openSans,
]
export default fonts
